import React, { Fragment } from 'react'
import DeleteFeatureModal from '../components/DeleteFeatureModal'
import FeatureIcon from 'components/icons/Feature'
import PageHeader from 'components/PageHeader'
import ListBox from 'components/ListBox'
import ListRow from 'components/ListRow'
import MoreMenu from 'components/MoreMenu'
import RouteAdminFeaturesGlobalIndexQuery from './index.query'
import Toggle from 'components/Toggle'
import ToggleFeatureMutation from 'components/mutations/ToggleFeature'
import { Alert, ButtonLink, SwitchInput } from 'stylist'
import { Query } from 'react-apollo'

const RouteAdminFeaturesGlobalIndex = ({ match: { url } }) => (
  <Query query={RouteAdminFeaturesGlobalIndexQuery}>
    {({ loading, data: { features = [] } }) => (
      <Fragment>
        <PageHeader columns="auto 1fr">
          <PageHeader.Icon>
            <FeatureIcon size="1.75rem" />
          </PageHeader.Icon>
          <PageHeader.Title>Features</PageHeader.Title>
          <ButtonLink kind="ghost" to={`${url}/new`}>
            Add Feature
          </ButtonLink>
        </PageHeader>
        <article>
          <Alert
            kind="warning"
            message="Do not enable or disable global features unless you are absolutely sure you understand the consequences"
          />
          <ListBox>
            {loading ? (
              <ListBox.Loader />
            ) : (
              features.map(feature => (
                <ListBox.Item hover key={feature.name}>
                  <ListRow templateColumns="1fr auto">
                    <ListRow.Cell>
                      <strong>{feature.name}</strong>
                    </ListRow.Cell>
                    <ListRow.Cell actions>
                      <ToggleFeatureMutation feature={feature}>
                        {({ toggleFeature }) => (
                          <SwitchInput
                            id={feature.name}
                            checked={feature.enabled}
                            label={feature.enabled ? 'On' : 'Off'}
                            onChange={e =>
                              toggleFeature({ enabled: e.target.checked })
                            }
                          />
                        )}
                      </ToggleFeatureMutation>
                      <MoreMenu horizontal>
                        <Toggle
                          initial={false}
                          render={({ on, enable, disable }) => (
                            <Fragment>
                              <DeleteFeatureModal feature={feature} />
                            </Fragment>
                          )}
                        />
                      </MoreMenu>
                    </ListRow.Cell>
                  </ListRow>
                </ListBox.Item>
              ))
            )}
          </ListBox>
        </article>
      </Fragment>
    )}
  </Query>
)

export default RouteAdminFeaturesGlobalIndex



// WEBPACK FOOTER //
// ./src/routes/admin/features/global/index.js